module.exports = __webpack_public_path__ + "static/media/8-3.963bef38.mp3";